module.exports = __webpack_public_path__ + "static/img/banner_cooperation.afb769f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/banner/banner_cooperation.jpg
// module id = IEwh
// module chunks = 15